import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { api_url } from "../../authorize";
import { AuthorizeContext } from "../../RootContext";

const SchemaFormBuilder = () => {

  const { token, role, user, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [loading, setLoading] = useState(true);
  const [cData, setCdata] = useState([]);
  const [iData, setIdata] = useState([]);
  const [fData, setFdata] = useState([]);
  const [pData, setPdata] = useState([]);


  // 1. The database/backend schema structure
  const Admin_SCHEMA = {
    case_id: "Case ID",
    site: "Partner",
    case_status: "Case Status",
    flag_status: "Flag",
    Implant: "Implant",
    Hospital_Country: "Hospital Country",
    Surgeon_Last_Name: "Surgeon Last Name",
    Patient_First_Name: "Patien First Name",
    Patient_Last_Name: "Patien Last Name",
    Patient_Surgery_Type: " Surgery Type",
    expedite: "Expedited (Y/N)",

  };

  const Parnter_SCHEMA = {
    case_id: "Case ID",
    // site: "Partner",
    // case_status: "Case Status",
    // flag_status: "Flag",
    // Implant: "Implant",
    // Hospital_Country: "Hospital Country",
    Surgeon_Last_Name: "Surgeon Last Name",
    Patient_First_Name: "Patien First Name",
    Patient_Last_Name: "Patien Last Name",
    Patient_Surgery_Type: " Surgery Type",
    // expedite: "Expedited (Y/N)",

  };

  let SCHEMA = Admin_SCHEMA;
  if (role.includes("partner")){
       SCHEMA = Parnter_SCHEMA;
      }

  // 2. State initialized dynamically using the schema keys
  const [formData, setFormData] = useState(() => {
    const initialValues = {};
    Object.keys(SCHEMA).forEach((key) => {
      initialValues[key] = ''; // Initialize every schema key with an empty string value
    });
    return initialValues;
  });
    const setupDrop = async () => {
     
      const res = await axios({
            url: `https://${api_url}/api/big_form_dropdowns?`,
            method: 'get',
            headers: {
                'x-access-token' : token
            }
          }).then(res=> {
            setCdata(res.data.countries);
            setIdata(res.data.implant_info);
            setFdata(res.data.flags);
            setPdata(res.data.partners);
          });
          setLoading(true) ;
    }
  useEffect(() => {
    setupDrop();
          console.log(cData);
          console.log(iData);
          console.log(fData);
          console.log(pData);
  },[]);

  // Handle change for any dynamic input field
  const handleInputChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value // Update the specific key with the user's input value
    }));
  };

  // Reset form helper
  const handleClearForm = () => {
    const clearedValues = {};
    Object.keys(SCHEMA).forEach((key) => {
      clearedValues[key] = '';
    });
    setFormData(clearedValues);
  };
  const grabDeepQuery=(maybe) =>{

  const fetchData = async () => {
     
      const qry = await axios({
            url: `https://${api_url}/api/case_list?`,
            method: 'patch',
            headers: {
                'x-access-token' : token
            },
            data:maybe,
            timeout:10000,
          })
          setLoading(true)
         
          localStorage.setItem('deepSearch',JSON.stringify(qry.data));
          window.location.reload();
  }
    fetchData();
}

  // Submit handler to send the pure JSON object to the backend
  const handleSubmit = (e) => {
    const update1 = JSON.stringify(formData).replaceAll("Surgeon_","Surgeon.")
    const update2 = update1.replaceAll("Patient_","Patient.")
    const update3 = update2.replaceAll("Hospital_","Hospital_")
    const maybe = JSON.parse(update3)
    e.preventDefault();
    grabDeepQuery(maybe);
    // formData is already a clean JSON object structured exactly as { key: value }
    console.log('Dispatching JSON Object to backend/db:', JSON.stringify(maybe, null, 2));
    
    // Example: fetch('/api/submit', { method: 'POST', body: JSON.stringify(formData) })
    alert('Deep Search Submitted');
  };

 return (
    <div style={styles.outerContainer}>
      {/* Form Card */}
      <div style={styles.formCard}>
        <h3 style={styles.title}>Deep Search Query</h3>
        <p style={styles.subtitle}></p>

        {/* Dynamic Horizontal Entry Form */}
        <form onSubmit={handleSubmit}>
          <div style={styles.horizontalGrid}>
            {Object.keys(SCHEMA).map((schemaKey) => {
               // OPTION A: Render as a Checkbox if the key matches 'is_active'
                if (schemaKey === 'expedite') {
                  return (
                    <div key={schemaKey} style={styles.formGroupCheckbox}>
                      <label style={styles.checkboxLabel} htmlFor={schemaKey}>
                        <input
                          id={schemaKey}
                          type="checkbox"
                          checked={!!formData[schemaKey]} // Force boolean type safely
                          onChange={(e) => handleInputChange(schemaKey, e.target.checked)} // e.target.checked captures true/false
                          style={styles.checkbox}
                        />
                        {SCHEMA[schemaKey]}
                      </label>
                    </div>
                  );
                }
                 // OPTION B: Render as a Dropdown Select menu if the key matches 'role'
                if (schemaKey === 'case_status') {
                  return (
                    <div key={schemaKey} style={styles.formGroup}>
                      <label style={styles.label} htmlFor={schemaKey}>
                        {SCHEMA[schemaKey]}
                      </label>
                      <select
                        id={schemaKey}
                        value={formData[schemaKey]}
                        onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                        style={styles.input} // Reuses your existing layout styles
                      >
                        <option value="">-- Select Case Status --</option>
                        <option value="Purchase_Order">New Order</option>
                        <option value="MRI">MRI</option>
                        <option value="MRI_QC">MRI QC</option>
                        <option value="Planning_1">Planning 1</option>
                        <option value="Planning_2">Planning 2</option>
                        <option value="Surgeon_approval">Surgeon Approved</option>
                        <option value="Template_design">Template Design</option>
                        <option value="G_code">G Code</option>
                        <option value="CNC">Manufacturing</option>
                        <option value="Final_QC">Final QC</option>
                        <option value="Shipped">Shipped</option>
                        <option value="Complete">Complete</option>
                        <option value="Abort">Abort</option>
                      </select>
                    </div>
                  );
                }
                 // OPTION B: Render as a Dropdown Select menu if the key matches 'role'
                if (schemaKey === 'Hospital_Country') {
                  return (
                    <div key={schemaKey} style={styles.formGroup}>
                      <label style={styles.label} htmlFor={schemaKey}>
                        {SCHEMA[schemaKey]}
                      </label>
                      <select
                        id={schemaKey}
                        value={formData[schemaKey]}
                        onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                        style={styles.input} // Reuses your existing layout styles
                      >
                        <option value="">-- Select Country --</option>
                        {cData?.map((dd, index) => (
                            <option key={index} value={dd[1]}>{dd[0]}</option>
                        ))}
                      </select>
                    </div>
                  );
                }
                 // OPTION B: Render as a Dropdown Select menu if the key matches 'role'
                if (schemaKey === 'Patient_Surgery_Type') {
                  return (
                    <div key={schemaKey} style={styles.formGroup}>
                      <label style={styles.label} htmlFor={schemaKey}>
                        {SCHEMA[schemaKey]}
                      </label>
                      <select
                        id={schemaKey}
                        value={formData[schemaKey]}
                        onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                        style={styles.input} // Reuses your existing layout styles
                      >
                        <option value="">-- Select Surgery Type --</option>
                        <option value="TKR">Knee</option>
                        <option value="THR">Hip</option>
                        {/*<option value="TAH">ANKLE</option>*/}
                      </select>
                    </div>
                  );
                }

                 // OPTION B: Render as a Dropdown Select menu if the key matches 'role'
                  if (schemaKey === 'Implant') {
                    return (
                      <div key={schemaKey} style={styles.formGroup}>
                        <label style={styles.label} htmlFor={schemaKey}>
                          {SCHEMA[schemaKey]}
                        </label>
                        <select
                          id={schemaKey}
                          value={formData[schemaKey]}
                          onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                          style={styles.input} // Reuses your existing layout styles
                        >
                          <option value="">-- Select Implant --</option>
                              {iData?.map((dd, index) => (
                                  <option key={index} value={dd.implant_name}>{dd.implant_name}</option>
                              ))}
                        </select>
                      </div>
                    );
                  }

                   if (schemaKey === 'site') {
                    return (
                      <div key={schemaKey} style={styles.formGroup}>
                        <label style={styles.label} htmlFor={schemaKey}>
                          {SCHEMA[schemaKey]}
                        </label>
                        <select
                          id={schemaKey}
                          value={formData[schemaKey]}
                          onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                          style={styles.input} // Reuses your existing layout styles
                        >
                          <option value="">-- Select Partner --</option>
                          <option value="Lento">Lento</option>
                              {pData?.map((dd, index) => (
                                  <option key={index} value={dd.First_Name}>{dd.First_Name}</option>
                              ))}
                        </select>
                      </div>
                    );
                  }

                   // OPTION B: Render as a Dropdown Select menu if the key matches 'role'
                    if (schemaKey === 'flag_status') {
                      return (
                        <div key={schemaKey} style={styles.formGroup}>
                          <label style={styles.label} htmlFor={schemaKey}>
                            {SCHEMA[schemaKey]}
                          </label>
                          <select
                            id={schemaKey}
                            value={formData[schemaKey]}
                            onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                            style={styles.input} // Reuses your existing layout styles
                          >
                            <option value="">-- Select Flag --</option>
                              {fData?.map((dd, index) => (
                                  <option key={index} value={dd.title}>{dd.title}</option>
                              ))}
                            
                          </select>
                        </div>
                      );
                    }
              return (
              <div key={schemaKey} style={styles.formGroup}>
                {/* The label displays the human-readable schema item */}
                <label style={styles.label} htmlFor={schemaKey}>
                  {SCHEMA[schemaKey]} 
                  {/*<span style={styles.keyTag}>({schemaKey})</span>*/}
                </label>
                
                {/* The input maps its value directly to that key in the JSON state */}
                <input
                  id={schemaKey}
                  type="text"
                  value={formData[schemaKey]}
                  onChange={(e) => handleInputChange(schemaKey, e.target.value)}
                  placeholder={`Enter ${SCHEMA[schemaKey].toLowerCase()}...`}
                  style={styles.input}
                />
              </div>
            );
            })}
          </div>

          <div style={styles.btnGroup}>
            <button type="submit" style={styles.submitBtn}>
              Submit
            </button>
            <button type="button" onClick={handleClearForm} style={styles.clearBtn}>
              Clear
            </button>
          </div>
        </form>
      </div>

      {/* Real-time JSON Live Output Panel */}
      {/*<div style={styles.previewCard}>
        <h3 style={styles.previewTitle}>Query Results</h3>
        <pre style={styles.jsonBlock}>
          {JSON.stringify(formData, null, 2)}
        </pre>
      </div>*/}
    </div>
  );
}

export default SchemaFormBuilder

const styles = {
  outerContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack the main sections vertically
    gap: '20px',
    maxWidth: '1100px',
    margin: '0 auto',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: '20px'
  },
  formCard: {
    padding: '15px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#EAF7FA',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  title: {
    margin: '0 0 4px 0',
    color: '#0A7A94',
    fontWeight: '800'
  },
  subtitle: {
    margin: '0 0 20px 0',
    fontSize: '13px',
    color: '#666'
  },
  horizontalGrid: {
    display: 'flex',
    flexWrap: 'wrap', // Allows inputs to break cleanly onto new lines if space runs out
    gap: '6px'
  },
  formGroup: {
    flex: '1 1 calc(10% )', // Targets roughly 3 horizontal columns per line
    minWidth: '160px', // Prevents fields from squeezing down too tiny on smaller monitors
    display: 'flex',
    flexDirection: 'column',
    gap: '0px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  keyTag: {
    fontSize: '11px',
    fontWeight: 'normal',
    color: '#888',
    fontFamily: 'monospace'
  },
  input: {
    padding: '5px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    outline: 'none',
    backgroundColor: '#fafafa',
    boxSizing: 'border-box',
    width: '100%'
  },
  btnGroup: {
    display: 'flex',
    gap: '12px',
    marginTop: '24px',
    justifyContent: 'flex-start'
  },
  submitBtn: {
    padding: '6px 12px',
    backgroundColor: '#0A7A94',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  },
  clearBtn: {
    padding: '6px 12px',
    backgroundColor: '#f5f5f5',
    color: '#333',
    border: '1px solid #ccc',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  previewCard: {
    padding: '24px',
    border: '1px solid #222',
    borderRadius: '8px',
    backgroundColor: '#1e1e1e',
    color: '#00ff66'
  },
  previewTitle: {
    margin: '0 0 12px 0',
    fontSize: '16px',
    color: '#fff',
    borderBottom: '1px solid #444',
    paddingBottom: '8px'
  },
  jsonBlock: {
    margin: 0,
    fontSize: '13px',
    fontFamily: 'Courier New, monospace',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap'
  },
  formGroupCheckbox: {
    flex: '1 1 calc(15%)',
    minWidth: '120px',
    display: 'flex',
    alignItems: 'flex-end', // Push checkbox lower down to match text baseline levels
    paddingBottom: '5px', 
    paddingLeft: '15px' 
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    cursor: 'pointer'
  },
  checkbox: {
    width: '18px',
    height: '18px',
    cursor: 'pointer'
  }
};
